document.querySelectorAll('.new-pdp-offers__card').forEach(function (card) {
  const inner = card.querySelector('.new-pdp-offers__card-inner');
  if (!inner) return;

  const originalHTML = inner.innerHTML;

  card.addEventListener('click', function () {
    const strongEl = inner.querySelector('strong');
    if (!strongEl) return;

    const couponCode = strongEl.innerText.trim().replace(/:$/, '').trim();

    navigator.clipboard.writeText(couponCode).then(() => {
      inner.style.alignItems = 'center';
      inner.style.justifyContent = 'center';
      inner.innerHTML = '<p class="new-pdp-offers__copied">Copied!!</p>';
      setTimeout(() => {
        inner.innerHTML = originalHTML;
        inner.style.alignItems = '';
        inner.style.justifyContent = '';
      }, 2000);
    });
  });
});